import { useQueryWithUserId } from '@northladder/services';

import { INBOUND_API } from '../../../inboundAPIClient';
import { IFetchSearchListUrlOptions } from '../../../types';

/**
 * This is to track the inbound status list from the backend.
 */
export const INBOUND_STATUS_LIST_KEY = 'inbound-status-list-query';

interface IInboundStatusListQuery {
  queryParams: IFetchSearchListUrlOptions;
}

/**
 * This hook fetches list of inbound status items from the backend.
 */
export const useInboundStatusListQuery = ({
  queryParams,
}: IInboundStatusListQuery) => {
  const {
    endDate,
    filterKey,
    limit,
    page,
    recordType,
    search,
    searchFields,
    searchKeywords,
    showOnly,
    sort,
    startDate,
  } = queryParams;
  const { data, error, isError, isFetching, isPending, refetch } =
    useQueryWithUserId({
      // eslint-disable-next-line @tanstack/query/exhaustive-deps
      queryKey: [
        INBOUND_STATUS_LIST_KEY,
        endDate,
        filterKey,
        limit,
        page,
        recordType,
        search,
        searchFields,
        searchKeywords,
        showOnly,
        sort,
        startDate,
      ],
      networkMode: 'always',
      queryFn: () => INBOUND_API.fetchInboundStatusList(queryParams),
    });

  return {
    statusData: data,
    statusError: error,
    isStatusError: isError,
    isStatusFetching: isFetching,
    isStatusLoading: isPending,
    refetchInboundStatusList: refetch,
  };
};
